import React, { useContext, useState, useEffect } from "react";
import { Radio } from "@material-ui/core";
import { Link } from "@reach/router";
import { useHomeUrl, usePrevLink } from "@utils/navigation";

import { NavigationContext } from "@components/TransitionRoot/NavigationContext";
import { useRouteData } from "react-static";
import { startingLocation } from "../../utils/config";

import { clearCinematic } from "../PersistedData/cinematicsSlice";
import { clearCollectable } from "../PersistedData/collectablesSlice";
import { setSavedLocation } from "../PersistedData/locationSlice";
import { clearPlace } from "../PersistedData/placesSlice";
import { useCurrentSettings, setMode } from "../PersistedData/settingsSlice";
import { isCompat } from "../../utils/interactivity";
import { useI18n } from "../../I18nextProvider";
import { useAppDispatch } from "../PersistedData/hooks";

/* eslint no-restricted-globals: "off" */

const Settings = () => {
  const i18n = useI18n();
  const dispatch = useAppDispatch();
  const settings = useCurrentSettings();
  const prevLink = usePrevLink();
  const [reinitPopupOpen, setReinitPopupOpen] = useState(false);
  const { goto } = useContext(NavigationContext);
  const homeUrl = useHomeUrl();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    goto(prevLink.path, prevLink.state);
  };

  const handleSelectFull = () => {
    dispatch(setMode("full"));
    goBack();
  };
  const handleSelectBasic = () => {
    dispatch(setMode("basic"));
    goBack();
  };
  const handleSelectNoScript = () => {
    dispatch(setMode("noscript"));
    goBack();
  };
  const handleOpenRenitialiserKey = (e) => {
    if (e.keyCode) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        handleOpenRenitialiser();
      }
    }
  };
  const handleOpenRenitialiser = () => {
    setReinitPopupOpen(true);
  };
  const handleCloseRenitialiser = (e) => {
    e.preventDefault();
    setReinitPopupOpen(false);
  };
  const handleReinitialiser = () => {
    dispatch(clearCinematic());
    dispatch(clearCollectable());
    dispatch(clearPlace());
    dispatch(setSavedLocation(startingLocation));
  };

  if (reinitPopupOpen) {
    return (
      <main className="settings reinit-popup">
        <div className="btn-et-titre">
          <Link
            aria-label={i18n.t("global.retour")}
            className="small-closing-btn"
            to={prevLink.path}
            state={prevLink.state}
          >
            <span>
              <span className="screen-reader-only">{i18n.t("global.retour")}</span>
            </span>
          </Link>
          <h1>{i18n.t("settings.reinit_confirmation")}</h1>
        </div>

        <div className="pop-content">
          <p>{i18n.t("settings.reinit_confirmation_texte")}</p>
          <div className="btn-choix">
            <a href={homeUrl} role="button" className="bouton-or" onClick={handleReinitialiser}>
              <span>{i18n.t("settings.reinit")}</span>
            </a>
            <a href="#" role="button" className="bouton-bronze" onClick={handleCloseRenitialiser}>
              <span>{i18n.t("settings.reinit_annuler")}</span>
            </a>
          </div>
        </div>
      </main>
    );
  }
  return (
    <main className="settings">
      <Link aria-label={i18n.t("global.retour")} className="fp-closing-btn" to={prevLink.path} state={prevLink.state}>
        <span className="screen-reader-only">{i18n.t("global.retour")}</span>
      </Link>
      <h1>{i18n.t("settings.title")}</h1>
      {(typeof document === "undefined" || !isCompat) && <p>{i18n.t("settings.erreur")}</p>}
      <div className="row" id="maincontent" tabIndex={-1}>
        <div className="vue vue1">
          <h2>{i18n.t("settings.mode_full")}</h2>
          <p>{i18n.t("settings.mode_full_texte")}</p>
          <Radio
            id="vueAmelioree"
            onClick={handleSelectFull}
            checked={settings.mode === "full"}
            disabled={typeof document === "undefined" || !isCompat}
            tabIndex={0}
          />
          <button type="button" onClick={handleSelectFull}>
            <span className="cocher"> {i18n.t("settings.btn_choisir")}</span>
            <span className="cocher_hover"> {i18n.t("settings.btn_choisir_hover")}</span>
          </button>
        </div>
        <div className="vue vue2">
          <h2>{i18n.t("settings.mode_basic")}</h2>
          <p>{i18n.t("settings.mode_basic_texte")}</p>
          <Radio
            id="vueAlternative"
            onClick={handleSelectBasic}
            checked={settings.mode === "basic"}
            disabled={typeof document === "undefined"}
            tabIndex={0}
          />
          <button type="button" onClick={handleSelectBasic}>
            <span className="cocher"> {i18n.t("settings.btn_choisir")}</span>
            <span className="cocher_hover"> {i18n.t("settings.btn_choisir_hover")}</span>
          </button>
        </div>
        <div className="vue vue3">
          <h2>{i18n.t("settings.mode_noscript")}</h2>
          <p>{i18n.t("settings.mode_noscript_texte")}</p>
          <Radio
            id="vueMinimal"
            onClick={handleSelectNoScript}
            checked={settings.mode === "noscript"}
            disabled={typeof document === "undefined"}
            tabIndex={0}
          />
          <button type="button" onClick={handleSelectNoScript}>
            <span className="cocher"> {i18n.t("settings.btn_choisir")}</span>
            <span className="cocher_hover"> {i18n.t("settings.btn_choisir_hover")}</span>
          </button>
        </div>
      </div>
      <div className="reinit">
        <h2>{i18n.t("settings.reinit")}</h2>
        <p>{i18n.t("settings.reinit_texte")}</p>
        {typeof document !== "undefined" && (
          <a
            tabIndex={0}
            role="button"
            className="bouton-or"
            type="button"
            onClick={handleOpenRenitialiser}
            onKeyDown={handleOpenRenitialiserKey}
          >
            <span>{i18n.t("settings.reinit")}</span>
          </a>
        )}
      </div>
    </main>
  );
};

export default Settings;
